module.exports = __webpack_public_path__ + "img/3-3.a5520473.png";